/**
 * @Author proudlx
 * @Description http请求方法
 */
import request from "@/api/http/request";
import { POST_BASE_DICT_LIST,POST_BASE_MARKET_PERMISSION_CHECK } from "@/api/apiConst";

// 类型定义
export interface dictItemType {
  createDate?: string;
  description?: string;
  id?: string;
  label: string;
  parentId?: string;
  remarks?: string;
  sort?: number;
  type?: string;
  updateDate?: string;
  value: string;
  status?: number;
  /** 类型别名 */
  otherName?: string;
  businessId?: string;
}

// 模块级缓存，key = type，value = Promise
const dictCache = new Map<string, Promise<any>>();

/** 字典列表请求 */
export function getDictList(data: { type: string }) {
  // return request.post<dictItemType[]>(POST_BASE_DICT_LIST, data);

  const cacheKey = data.type;
  const cached = dictCache.get(cacheKey);
  if (cached) {
    return cached;   // 命中缓存，直接复用同一个 Promise
  }
  const promise = request.post<dictItemType[]>(POST_BASE_DICT_LIST, data).then(res => {
    dictCache.set(cacheKey, promise);  // 存回缓存（实际应存结果，此处简化描述）
    return res;
  });
  dictCache.set(cacheKey, promise);
  return promise;
}

export interface marketPermissionCheckType {
  check: boolean;
  userType: string;
}
export function marketPermissionCheck(data: { marketId: string }) {
  return request.post<marketPermissionCheckType>(POST_BASE_MARKET_PERMISSION_CHECK, data);
}
